export function assertOneOf(componentName, propertyName, value, allowedValues) {
  if (!allowedValues.includes(value)) {
    throw new Error(
      `[WUI_INVALID_CONTRACT] ${componentName}.${propertyName} must be one of: ${allowedValues.join(
        ", "
      )}.`
    );
  }
}

export function assertNonEmptyString(componentName, propertyName, value) {
  if (typeof value !== "string" || value.trim().length === 0) {
    throw new Error(
      `[WUI_MISSING_ACCESSIBLE_NAME] ${componentName}.${propertyName} must be a non-empty string.`
    );
  }
}
